import axios from 'axios';
import { useEffect, useMemo, useState } from 'react';
import { NO_IMAGE_PLACEHOLDER_URL } from 'shared/constants/ASSETS_URL';
import { uploadService } from 'shared/services/uploadService';
import { getMediaId } from 'shared/utils/auditionMediaAttachments';
import { getThumbnailUrl } from 'shared/utils/getThumbnailUrl';

const { getSingleMedia } = uploadService();
export const useGetThumbnail = () => {
  const [videoUrl, setVideoUrl] = useState<string>('');

  const [isErrorThumbnail, setIsErrorThumbnail] = useState<boolean>(false);
  const { data, isLoading } = getSingleMedia(getMediaId(videoUrl));

  const thumbnail = useMemo(() => {
    if (!isLoading) {
      return data ? getThumbnailUrl(data) : NO_IMAGE_PLACEHOLDER_URL;
    }
  }, [data, isLoading]);

  const handleChangeVideoUrl = (url: string) => {
    setVideoUrl(url);
  };

  console.log({ videoUrl });

  useEffect(() => {
    (async () => {
      try {
        if (thumbnail) {
          await axios.get(thumbnail, {
            responseType: 'blob',
            headers: {
              accept: 'application/json',
            },
          });
        }
        setIsErrorThumbnail(false);
      } catch (err) {
        setIsErrorThumbnail(true);
      }
    })();
  }, [thumbnail]);

  console.log('thumbnail', thumbnail);

  return {
    thumbnail,
    videoUrl,
    isLoading,
    isErrorThumbnail,
    handleChangeVideoUrl,
  };
};
